function HomeProductsSlick() {
    const homeProducts = document.getElementById("HomeProducts")

    if (homeProducts) {
        $(".BannerProductList .ProductsContainer").slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right-arrow'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left-arrow'></i></div>",
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        slidesToShow: 2.5,
                        slidesToScroll: 2,
                        infinite: false,
                        dots: true,
                    }
                }
            ]
        });
    }
}

function AnoncementSwiper() {
    if ($(".anoncement-swapper").length > 0) {
        $(".anoncement-swapper .slide-wrapper").slick({
            dots: false,
            arrows: false,
            autoplay: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3500,
            vertical: true,
            verticalSwiping: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        vertical: false,
                        verticalSwiping: false
                    }
                }
            ]
        });
    }
}

function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")
    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")
    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }

}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }


                }
            }
            settingTextBanner();
        }
    });
}

function setCookie(cookieName, cookieValue) {

    var expiresDate = new Date();
    expiresDate.setTime(expiresDate.getTime() + 1000 * 60 * 60 * 3);
    $.cookie(cookieName, cookieValue, { path: '/', expires: expiresDate });

}

function getCookie(cookieName) {

    var cookieValue = $.cookie(cookieName);
    return cookieValue;
}

function removeCookie() {

    var isRemoved = $.removeCookie(cookieName);
    if (isRemoved)
        console.log('Cookie ' + cookieName + ' has been removed.');
    else
        console.log('Cookie ' + cookieName + ' not removed.');
}

function GetClickSocialMediaButton() {

    //facebook gtag
    $('footer #SocialMediaFacebook').click(function () {
        dataLayer.push({
            'event': 'custom_event',
            'event_category': 'click',
            'event_action': 'social_media_icon_click',
            'social_media_icon_name': 'facebook'
        });
    });

    //twitter gtag
    $('footer #SocialMediaTwitter').click(function () {
        dataLayer.push({
            'event': 'custom_event',
            'event_category': 'click',
            'event_action': 'social_media_icon_click',
            'social_media_icon_name': 'twitter'
        });
    });

    //instagram gtag
    $('footer #SocialMediaInstagram').click(function () {
        dataLayer.push({
            'event': 'custom_event',
            'event_category': 'click',
            'event_action': 'social_media_icon_click',
            'social_media_icon_name': 'instagram'
        });
    });

    //youtube gtag
    $('footer #SocialMediaYoutube').click(function () {
        dataLayer.push({
            'event': 'custom_event',
            'event_category': 'click',
            'event_action': 'social_media_icon_click',
            'social_media_icon_name': 'youtube'
        });
    });

}

function HomeSelectDetailClick() {
    $(document).on("click", ".Product-Card-Item-ImgBox>a", function (e) {

        e.preventDefault();

        var $itemSelected = $(this).parent().parent().find('.Product-Card-Item-Info .product-info');

        var UserID = $('#UserID').val();

        if (!UserID || UserID == "0")
            UserID = "unknown";

        var dataProductName = $itemSelected.attr('data-productname');

        var dataProductDiscount = $itemSelected.attr('data-productdiscount').replace(',', '.');

        var dataProductListPosition = $itemSelected.attr('data-listposition') - 1;

        var dataProductColorName = $itemSelected.attr('data-colorname');

        var dataProductAmount = $itemSelected.attr('data-productamount').replace(',', '.');

        var dataProductCode = $itemSelected.attr('data-productcode');

        var dataColorCode = $itemSelected.attr('data-colorcode');

        var item_id_Home = dataProductCode + "-R" + dataColorCode;

        dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.

        dataLayer.push({
            event: "ecom_event",
            event_category: "ecommerce",
            event_action: "select_promotion",
            ecommerce: {
                creative_name: "BSL",
                creative_slot: "Home-ProductReco",
                promotion_name: "Home-ProductReco",
                items: [{
                    item_id: item_id_Home,
                    item_group_id: dataProductCode,
                    item_name: dataProductName,
                    currency: "TRY",
                    discount: parseFloat(dataProductDiscount),
                    index: parseInt(dataProductListPosition),
                    item_brand: "BSL",
                    item_category: "",
                    item_category2: "",
                    item_list_id: "40",
                    item_list_name: "yeniler",
                    item_variant: null,
                    item_size: null,
                    item_color: dataProductColorName,
                    price: parseFloat(dataProductAmount)
                }]
            }
        });

        document.location.href = $(this).attr("href");
    });
}

function isOnScreen(elem) {
    if (elem.length == 0) {
        return;
    }

    var $window = jQuery(window);

    var viewport_top = $window.scrollTop();

    var viewport_height = $window.height();

    var viewport_bottom = viewport_top + viewport_height;

    var $elem = jQuery(elem);

    var top = $elem.offset().top;

    var height = $elem.height();

    var bottom = top + height;

    return (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

function HomeSliderViewGtagDatalayerProducts(isSwipe) {

    if (!isSwipe) {
        $(window).scroll(function () {

            if (isOnScreen($("#HomeProducts")) == true) {

                // console.log("enter");

                var productList = $(".ProductsContainer .Product.slick-active");

                var productListFirst = []; // Boş bir dizi oluştur

                var productChunkFirst = productList;
                productChunkFirst.each(function (index, element) {

                    if (!$(element).hasClass('datalayerpush')) {

                        $(element).addClass('datalayerpush');

                        var productInfo = $(element).find(".product-info")

                        var UserID = $('#UserID').val();

                        if (!UserID || UserID == "0")
                            UserID = "unknown";

                        var dataProductName = productInfo.attr('data-productname');

                        var dataProductDiscount = productInfo.attr('data-productdiscount').replace(',', '.');

                        var dataProductListPosition = productInfo.attr('data-listposition') - 1;

                        var dataProductColorName = productInfo.attr('data-colorname');

                        var dataProductAmount = productInfo.attr('data-productamount').replace(',', '.');

                        var dataProductCode = productInfo.attr('data-productcode');

                        var dataColorCode = productInfo.attr('data-colorcode');

                        var item_id_Home = dataProductCode + "-R" + dataColorCode;

                        var viewPromotionFirst = {
                            item_id: item_id_Home,
                            item_group_id: dataProductCode,
                            item_name: dataProductName,
                            currency: "TRY",
                            discount: parseFloat(dataProductDiscount),
                            index: parseInt(dataProductListPosition),
                            item_brand: "BSL",
                            item_category: "",
                            item_category2: "",
                            item_list_id: "40",
                            item_list_name: "yeniler",
                            item_variant: null,
                            item_size: null,
                            item_color: dataProductColorName,
                            price: parseFloat(dataProductAmount)
                        }

                        productListFirst.push(viewPromotionFirst);
                    }
                });

                if (productListFirst.length > 0) {

                    // push
                    dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                    dataLayer.push({
                        event: "ecom_event",
                        event_category: "ecommerce",
                        event_action: "view_promotion",
                        ecommerce: {
                            creative_name: "BSL",
                            creative_slot: "Home-ProductReco",
                            promotion_name: "Home-ProductReco",
                            items: [productListFirst]
                        }
                    });
                }
            }
        });
    }
    else {
        if (isOnScreen($("#HomeProducts")) == true) {

            // console.log("enter");

            var productList = $(".ProductsContainer .Product.slick-active");

            var productListFirst = []; // Boş bir dizi oluştur

            var productChunkFirst = productList;
            productChunkFirst.each(function (index, element) {

                if (!$(element).hasClass('datalayerpush')) {

                    $(element).addClass('datalayerpush');

                    var productInfo = $(element).find(".product-info")

                    var UserID = $('#UserID').val();

                    if (!UserID || UserID == "0")
                        UserID = "unknown";

                    var dataProductName = productInfo.attr('data-productname');

                    var dataProductDiscount = productInfo.attr('data-productdiscount').replace(',', '.');

                    var dataProductListPosition = productInfo.attr('data-listposition') - 1;

                    var dataProductColorName = productInfo.attr('data-colorname');

                    var dataProductAmount = productInfo.attr('data-productamount').replace(',', '.');

                    var dataProductCode = productInfo.attr('data-productcode');

                    var dataColorCode = productInfo.attr('data-colorcode');

                    var item_id_Home = dataProductCode + "-R" + dataColorCode;

                    var viewPromotionFirst = {
                        item_id: item_id_Home,
                        item_group_id: dataProductCode,
                        item_name: dataProductName,
                        currency: "TRY",
                        discount: parseFloat(dataProductDiscount),
                        index: parseInt(dataProductListPosition),
                        item_brand: "BSL",
                        item_category: "",
                        item_category2: "",
                        item_list_id: "40",
                        item_list_name: "yeniler",
                        item_variant: null,
                        item_size: null,
                        item_color: dataProductColorName,
                        price: parseFloat(dataProductAmount)
                    }

                    productListFirst.push(viewPromotionFirst);
                }
            });

            if (productListFirst.length > 0) {

                // push
                dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                dataLayer.push({
                    event: "ecom_event",
                    event_category: "ecommerce",
                    event_action: "view_promotion",
                    ecommerce: {
                        creative_name: "BSL",
                        creative_slot: "Home-ProductReco",
                        promotion_name: "Home-ProductReco",
                        items: [productListFirst]
                    }
                });
            }
        }
    }
}

$(window).load(function () {
    $(".UseLazyLoad").Lazy();
});



$(document).ready(function () {

    settingTextBanner();
    GetLayoutTextBanners();
    GetClickSocialMediaButton();
    HomeProductsSlick();
    AnoncementSwiper();
    HomeSelectDetailClick();
    HomeSliderViewGtagDatalayerProducts(false);
    $('.ProductsContainer').on('swipe', function (event, slick, direction) {
        HomeSliderViewGtagDatalayerProducts(true);
    });

    $('.ProductsContainer').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        HomeSliderViewGtagDatalayerProducts(true);
    });

    $('.Home .SBanner').carousel({
        interval: 3000,
        keyboard: true
    });

    $(document).on("mouseenter", ".ProductsContainer .Product .Product-Card-Item-ImgBox", function () {
        $(this).find(".img2").css("display", "inline-block");
        $(this).find(".img1").css("display", "none");
    });

    $(document).on("mouseleave", ".ProductsContainer .Product .Product-Card-Item-ImgBox", function () {
        $(this).find(".img2").css("display", "none");
        $(this).find(".img1").css("display", "inline-block");
    });

    //if ($("#CookieNotificationArea").length > 0) {
    //    $("#CookieNotificationArea #CookieCloseBtn, #CookieAcceptBtn").click(function () {

    //        $("#CookieNotificationArea").css("display", "none");
    //        $("footer #Legal").css("margin-bottom", "0px");

    //    });

    //    var cookieName = 'Site1Cookie_Notification';
    //    var cookieValue = 'Site1Cookie_val280518';

    //    if (typeof getCookie(cookieName) == "undefined") {

    //        $("#CookieNotificationArea").css("display", "block");

    //        setCookie(cookieName, cookieValue);
    //    }
    //}

    if ($('#ShowAdvantageModal').length > 0 && $('body').hasClass("Home")) {

        var advantageModalCookieKey = 'AdvantageModalShow';

        var advantageModalCookieValue = 'YES';

        if (typeof getCookie(advantageModalCookieKey) == "undefined") {

            if ($(window).width() < 992) {
                $('#ShowAdvantageModal').modal("show");
            }
            else {
                $("#ShowAdvantageModal").modal({
                    keyboard: false,
                    handleUpdate: false,
                    backdrop: 'static'
                });
            }

            setCookie(advantageModalCookieKey, advantageModalCookieValue);
        }
    }

    if ($("#video-banner-desktop").length > 0) {

        var videoPath = "https://player.vimeo.com/progressive_redirect/playback/896077420/rendition/1080p/file.mp4?loc=external&signature=c072564a1500f5c0bc2b44433c22cb87eb0ee279ee02c5504d6360b94bcd04da";


        if ($(window).width() < 992) {
            videoPath = "https://player.vimeo.com/progressive_redirect/playback/896070950/rendition/540p/file.mp4?loc=external&signature=7275c1aa6c329e37bf8eb64b6c2073d319ad6ef7e46f0e3e1d6fe378d1c579ef";
        }

        var player = videojs('video-banner-desktop');

        player.ready(function () {
            this.src({
                src: videoPath,
                type: 'video/mp4'
            });

            player.play();
        });
    }

    // Global olarak sitede ülke değiştirme işlemini olduğunda bunu yakalayan js olayı
    $(document).on("change", ".GeneralCountryCodeChanger", function () {

        var selectedOption = $(this).find('option:selected');

        // Get the value and data attributes of the selected option
        var selectedValue = selectedOption.val();
        var _selectedCurrencyId = selectedOption.data('currencyid');
        var _selectedlangcode = selectedOption.data('langcode');

        console.log('selectedValue: ', selectedValue);
        console.log('selectedCode: ', _selectedCurrencyId);
        console.log('selectedCode2: ', _selectedlangcode);

        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/Home/ChangeCurrency",
            data: 'currencyID=' + _selectedCurrencyId + '&CountryCode=' + _selectedlangcode,
            success: function (dt) {

                console.log("GeneralCountryCodeChanger:", dt);

                if (dt.Sonuc == true) {

                    //if (dt.IslemSonucAciklama === "Telefon numarası zaten onaylı.Doğrulama adımları tamamlanmıştır.İşlemi tamamlayabilirsiniz.") {
                    //    // Sistemde telefonu kayıtlı ve onaylı olan kullanıcılar üye kayıdı oluşturmak istediği zaman
                    //    $.ajax({
                    //        type: "POST",
                    //        url: "/" + $("#SmallLangCode").val() + "/p/User/UserAdd",
                    //        data: $(".UyeOlModal").serialize(),
                    //        success: function (re) {

                    //            console.log("test: ", dt)

                    //            if (re.Sonuc == true) {
                    //                if (re.JsonRs == "Redirect") {
                    //                    window.location = "/tr/p/CheckOut/sepet?rf=sepet";
                    //                }
                    //            } else {
                    //                SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    //            }
                    //        }
                    //    });
                    //} else {
                    //    GenerateLocalLoading($("body"), "hide");
                    //    $("#ConfirmCodeAlert").html(gsm + " Numaralı hatta onay kodu gönderilmiştir.")
                    //    $("#ConfirmCodeAlert").addClass("alert-success");
                    //    $("#confimCodeModal").modal('show');
                    //}
                } else {
                    //SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    //GenerateLocalLoading($("body"), "hide");
                }

                document.location.reload();
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
            }
        });

        //return false;
    });

    /*
        if ($("#video-banner2-desktop").length > 0) {
    
            var videoPath2 = "https://player.vimeo.com/progressive_redirect/download/749867137/rendition/1080p/s%C4%B0te_banner_%C3%87ali%C5%9Emalari_-9_copy_3%20%281080p%29.mp4?loc=external&signature=c9350127aacbc6f7f98482f85331a0e66bc124c07c03c5ab5d8cf51129bb9c6d";
    
    
            if ($(window).width() < 992) {
                videoPath2 = "https://player.vimeo.com/progressive_redirect/download/749867057/rendition/480p/mobil_sewat-_1%20%28480p%29.mp4?loc=external&signature=2159ecf04ac98a30a6e818eca42b20c6e62f27a85f554f84817e7c4d08fc5fc9";
            }
    
            var player2 = videojs('video-banner2-desktop');
    
            player2.ready(function () {
                this.src({
                    src: videoPath2,
                    type: 'video/mp4'
                });
    
                player2.play();
            });
        }
    */

    // #region ReturnProduct
    $(document).on("click", ".productOperations .ReturnProductMemberless", function () {
        var orderedItemsID = $(this).attr("data-id");
        var ItemRow = $(this).closest(".SepetRow");

        if (orderedItemsID) {
            GenerateLocalLoading(ItemRow, "show");

            GetRetOrdersMemberlessForm(orderedItemsID, function (status, data) {
                if (status) {
                    ItemRow.find(".ReturnMemberlessProductReason").html(data);
                }
                else {
                    SwalGenerate("error", data, "İşlem Başarısız", "Tekrar Dene");
                }

                GenerateLocalLoading(ItemRow, "hide");
            });
        }
    });

    $(document).on("submit", ".ReturnMemberlessProductReason .RetOrderMemberlessForm", function () {
        form = $(this);
        var ItemRow = $(this).closest(".SepetRow");
        GenerateLocalLoading(ItemRow, "show");

        AccountAjaxForms(form, function (status, message) {
            GenerateLocalLoading(ItemRow, "hide");

            if (!status) {
                SwalGenerate("error", message, "İşlem Başarısız", "Tekrar Dene");
                return false;
            }

            SwalGenerate("success", message, "İşlem Başarılı", "Kapat");
            ItemRow.find(".ReturnMemberlessProductReason").html("");
            ItemRow.find(".ReturnProductMemberlessContainer").html("");
        });

        return false;
    });

    $(document).on("click", ".ReturnMemberlessProductReason .btn.cancel", function () {
        var ItemRow = $(this).closest(".SepetRow");
        ItemRow.find(".ReturnMemberlessProductReason").html("");
    });
    // #endregion
});